<template>
  <BottomModal :visible="show" :full-height="true" background-color="#ffffff" @close="handleClose">
    <template #default>
      <div class="success-wrapper">

        <!-- Fundo decorativo com confetti CSS -->
        <div class="confetti-bg" aria-hidden="true">
          <span v-for="n in 18" :key="n" :class="`confetti-piece confetti-${n}`"></span>
        </div>

        <!-- Ícone principal -->
        <div class="success-icon-circle">
          <i class="fa-solid fa-gift"></i>
        </div>

        <!-- Conteúdo principal -->
        <div class="success-body">
          <h2 class="success-headline">Presente enviado! 🎉</h2>
          <p class="success-sub">
            Sua contribuição chegou com sucesso.<br>
            Que momento especial! 🥰
          </p>
        </div>

        <!-- Card de compartilhamento (opcional) -->
        <div v-if="eventShareUrl" class="share-card">
          <p class="share-label">
            <i class="fa-solid fa-link me-1"></i> Compartilhe o evento
          </p>
          <div class="share-url-row">
            <span class="share-url-text">{{ shortUrl }}</span>
            <button class="btn-copy" @click="copyLink" :class="{ copied: linkCopied }">
              <i :class="linkCopied ? 'fa-solid fa-check' : 'fa-regular fa-copy'"></i>
              {{ linkCopied ? 'Copiado!' : 'Copiar' }}
            </button>
          </div>
        </div>

        <!-- Ações -->
        <div class="success-actions">
          <button class="btn-primary-pink" @click="handleRedirect">
            <i class="fa-solid fa-arrow-left me-2"></i>
            Voltar ao evento
          </button>
          <button v-if="eventShareUrl" class="btn-share-whatsapp" @click="shareWhatsapp">
            <i class="fa-brands fa-whatsapp me-2"></i>
            Compartilhar no WhatsApp
          </button>
        </div>

      </div>
    </template>
  </BottomModal>
</template>

<script>
import BottomModal from '@/components/BottomModal.vue';

export default {
  name: 'PaymentSuccessModal',
  components: { BottomModal },

  props: {
    show:          { type: Boolean, default: false },
    eventId:       { type: String, required: true },
    eventShareUrl: { type: String, default: '' },
  },

  emits: ['close', 'redirect-event'],

  data() {
    return {
      linkCopied: false,
    };
  },

  computed: {
    shortUrl() {
      if (!this.eventShareUrl) return '';
      return this.eventShareUrl
        .replace(/^https?:\/\//, '')
        .replace(/\/$/, '');
    },
  },

  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleRedirect() {
      this.$emit('redirect-event', this.eventId);
    },
    async copyLink() {
      try {
        await navigator.clipboard.writeText(this.eventShareUrl);
        this.linkCopied = true;
        setTimeout(() => { this.linkCopied = false; }, 2500);
      } catch {
        const el = document.createElement('textarea');
        el.value = this.eventShareUrl;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        this.linkCopied = true;
        setTimeout(() => { this.linkCopied = false; }, 2500);
      }
    },
    shareWhatsapp() {
      const text = encodeURIComponent(
        `🎁 Acabei de enviar um presente! Veja o evento aqui: ${this.eventShareUrl}`
      );
      window.open(`https://wa.me/?text=${text}`, '_blank');
    },
  },
};
</script>

<style scoped>
.success-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2.5rem 1.5rem 2rem;
  overflow: hidden;
  min-height: 100%;
  background: #ffffff;
}

.success-icon-circle {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff50a3 0%, #ff8fd1 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  box-shadow: 0 8px 24px rgba(255, 80, 163, 0.35);
  animation: pop-in 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both;
  z-index: 1;
}

.success-icon-circle i {
  font-size: 2.4rem;
  color: #ffffff;
}

@keyframes pop-in {
  0%   { transform: scale(0.4); opacity: 0; }
  100% { transform: scale(1);   opacity: 1; }
}

.success-body {
  z-index: 1;
  margin-bottom: 1.75rem;
}

.success-headline {
  font-size: 1.65rem;
  font-weight: 700;
  color: #32355d;
  margin-bottom: 0.5rem;
  line-height: 1.25;
}

.success-sub {
  font-size: 0.975rem;
  color: #6b7280;
  line-height: 1.6;
  margin: 0;
}

.share-card {
  width: 100%;
  max-width: 380px;
  background: #fdf2f8;
  border: 1.5px solid #fbc8e4;
  border-radius: 1rem;
  padding: 0.9rem 1rem;
  margin-bottom: 1.5rem;
  z-index: 1;
}

.share-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #ff50a3;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 0.5rem;
}

.share-url-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #fff;
  border: 1px solid #f0c4dc;
  border-radius: 0.6rem;
  padding: 0.4rem 0.5rem 0.4rem 0.75rem;
}

.share-url-text {
  flex: 1;
  font-size: 0.82rem;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.btn-copy {
  flex-shrink: 0;
  background: #ff50a3;
  color: #fff;
  border: none;
  border-radius: 0.5rem;
  padding: 0.3rem 0.75rem;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  transition: background 0.2s;
  white-space: nowrap;
}

.btn-copy.copied {
  background: #16a34a;
}

.btn-copy:hover:not(.copied) {
  background: #e0408e;
}

.success-actions {
  width: 100%;
  max-width: 380px;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  z-index: 1;
}

.btn-primary-pink {
  width: 100%;
  background: linear-gradient(135deg, #ff50a3, #ff8fd1);
  color: #fff;
  border: none;
  border-radius: 0.85rem;
  padding: 0.875rem 1.5rem;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 14px rgba(255, 80, 163, 0.35);
  transition: transform 0.15s, box-shadow 0.15s;
}

.btn-primary-pink:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(255, 80, 163, 0.45);
}

.btn-primary-pink:active {
  transform: translateY(0);
}

.btn-share-whatsapp {
  width: 100%;
  background: #fff;
  color: #25D366;
  border: 1.5px solid #25D366;
  border-radius: 0.85rem;
  padding: 0.75rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, color 0.2s;
}

.btn-share-whatsapp:hover {
  background: #25D366;
  color: #fff;
}

.confetti-bg {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  pointer-events: none;
  overflow: hidden;
  z-index: 0;
}

.confetti-piece {
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 2px;
  opacity: 0;
  animation: confetti-fall 3.5s ease-in forwards;
}

.confetti-1  { left: 5%;  background: #ff50a3; animation-delay: 0.0s; animation-duration: 3.2s; transform: rotate(20deg); }
.confetti-2  { left: 12%; background: #fbbf24; animation-delay: 0.2s; animation-duration: 3.8s; width: 6px; height: 10px; }
.confetti-3  { left: 20%; background: #60a5fa; animation-delay: 0.1s; animation-duration: 3.0s; border-radius: 50%; }
.confetti-4  { left: 30%; background: #ff50a3; animation-delay: 0.4s; animation-duration: 3.5s; }
.confetti-5  { left: 38%; background: #a78bfa; animation-delay: 0.0s; animation-duration: 4.0s; width: 5px; height: 12px; }
.confetti-6  { left: 47%; background: #34d399; animation-delay: 0.3s; animation-duration: 3.3s; }
.confetti-7  { left: 55%; background: #fbbf24; animation-delay: 0.5s; animation-duration: 3.7s; border-radius: 50%; }
.confetti-8  { left: 63%; background: #ff50a3; animation-delay: 0.1s; animation-duration: 3.1s; }
.confetti-9  { left: 72%; background: #60a5fa; animation-delay: 0.6s; animation-duration: 3.9s; width: 10px; height: 6px; }
.confetti-10 { left: 80%; background: #a78bfa; animation-delay: 0.2s; animation-duration: 3.4s; }
.confetti-11 { left: 88%; background: #34d399; animation-delay: 0.4s; animation-duration: 3.6s; border-radius: 50%; }
.confetti-12 { left: 95%; background: #fbbf24; animation-delay: 0.0s; animation-duration: 3.2s; }
.confetti-13 { left: 8%;  background: #a78bfa; animation-delay: 0.7s; animation-duration: 4.1s; width: 6px; height: 10px; }
.confetti-14 { left: 25%; background: #34d399; animation-delay: 0.3s; animation-duration: 3.5s; transform: rotate(-15deg); }
.confetti-15 { left: 43%; background: #fbbf24; animation-delay: 0.8s; animation-duration: 3.8s; border-radius: 50%; }
.confetti-16 { left: 60%; background: #ff50a3; animation-delay: 0.5s; animation-duration: 3.0s; width: 12px; height: 5px; }
.confetti-17 { left: 75%; background: #60a5fa; animation-delay: 0.2s; animation-duration: 3.6s; }
.confetti-18 { left: 92%; background: #ff50a3; animation-delay: 0.9s; animation-duration: 4.0s; transform: rotate(45deg); }

@keyframes confetti-fall {
  0%   { opacity: 1; top: -10px; transform: translateX(0) rotate(0deg); }
  100% { opacity: 0; top: 110%;  transform: translateX(40px) rotate(360deg); }
}
</style>